//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      collapseAll: false,
      expandAll: false
    }
  },
  props: {
    buttonClicked: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    collapseAllFunc () {
      this.collapseAll = true
      this.expandAll = false
      this.$emit('collapseAll')
    },
    expandAllFunc () {
      this.expandAll = true
      this.collapseAll = false
      this.$emit('expandAll')
    }
  },
  computed: {
    collapseAllDown () {
      return this.buttonClicked ? this.collapseAll : false
    },
    expandAllDown () {
      return this.buttonClicked ? this.expandAll : false
    }
  }
}
